import { Box, ButtonNew, Image, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { Linking } from 'react-native'
import chatImg from '../../../assets/images/chat_icon.png'
import { SvgImage } from '../../../comps/SvgImage'
import { supportStrings } from '../../../data/static/strings'
import { useStores } from '../../../data/store'
import { APIEndPoints } from '../../../network/APIEndpoints'
import { Colors } from '../../../util/util.web'
import { chatbotAwarenessData } from '../ChatbotAwareness'
import { styles } from './styles'

const Support: FC = () => {
  const { mid } = useStores((store) => ({
    mid: store.user.selectedMid,
  }))
  const openMailClient = () => {
    Linking.openURL(`mailto:${supportStrings.emailId}`)
  }

  return (
    <Box {...styles.maincontainer}>
      <Box {...styles.container} ph={0} flex={1}>
        <Box pb={16} ph={16} borderBottomWidth={1} borderBottomColor="DISABLED_GREY">
          <Text {...styles.heading}>Help & Support</Text>
        </Box>
        <Box ph={16} f={1} align="center" overflow={'scroll'} paddingTop={128}>
          <Box {...styles.wraperItemStyle}>
            <Box>
              <Image width={48} height={48} resizeMode={'stretch'} source={chatImg} />
            </Box>
            <Spacer size={24} direction="horizontal" />
            <Box>
              <Box>
                <Text {...styles.title}>For Quick Support, Chat with Us</Text>
              </Box>
              <Spacer size={16} direction="vertical" />
              <Box>
                {Object.keys(chatbotAwarenessData)?.map((i, key) => (
                  <Box key={`item-${key}`} flexDirection={'row'} pb={8}>
                    <Box>
                      <SvgImage imageName="SuccessIconTickSmall" />
                    </Box>
                    <Spacer size={12} direction="horizontal" />
                    <Box f={1}>
                      <Text {...styles.textList}>{chatbotAwarenessData[i]}</Text>
                    </Box>
                  </Box>
                ))}
              </Box>
              <Box align="flex-start" justify="flex-start" mt={8}>
                <ButtonNew
                  width={110}
                  height={42}
                  onPress={() => {
                    if (window.trigger_intent_224) {
                      const trigger_intent_metadata = {
                        need_help_mid: mid,
                      }
                      window.trigger_intent_224(trigger_intent_metadata)
                    }
                  }}
                  type={'primary'}
                  color={Colors.BLUE_SHADE_PRIMARY}
                  underlayColor={Colors.BLUE_SHADE_PRIMARY}>
                  <Text {...styles.textList} fontFamily="JioType-Medium" color={'WHITE'}>
                    Chat with us
                  </Text>
                </ButtonNew>
              </Box>
            </Box>
          </Box>

          <Spacer size={24} direction="vertical" />

          <Box
            {...styles.wraperItemStyle}
            align="center"
            justify="space-between"
            onPress={openMailClient}
            underlayColor="TRANSPARENT">
            <Box flexDirection={'row'} align="center">
              <Box {...styles.circleIcon}>
                <SvgImage imageName="MailIcon" />
              </Box>
              <Spacer size={24} direction="horizontal" />
              <Box>
                <Box>
                  <Text {...styles.title} lineHeight={22}>
                    Alternatively, Email us at
                  </Text>
                </Box>
                <Box>
                  <Text {...styles.textList} color={'BLUE'} fontSize={14} fontFamily="JioType-Bold">
                    {supportStrings.emailId}
                  </Text>
                </Box>
              </Box>
            </Box>
            <Box alignSelf="center">
              <SvgImage imageName="FaqArrowRight" color={Colors.BLUE_SHADE_PRIMARY} />
            </Box>
          </Box>

          <Spacer size={24} direction="vertical" />

          <Box
            {...styles.wraperItemStyle}
            align="center"
            justify="space-between"
            underlayColor={'TRANSPARENT'}
            onPress={() => {
              Linking.openURL(APIEndPoints.faqs)
            }}>
            <Box flexDirection={'row'} align="center">
              <Box {...styles.circleIcon}>
                <SvgImage imageName="HelpIcon" />
              </Box>
              <Spacer size={24} direction="horizontal" />
              <Box>
                <Text {...styles.title} lineHeight={22}>
                  Frequently Asked Questions
                </Text>
              </Box>
            </Box>
            <Box alignSelf="center">
              <SvgImage imageName="FaqArrowRight" color={Colors.BLUE_SHADE_PRIMARY} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Support
